__turbopack_context__.v({
  "accommodationName": "_7wPzUq_accommodationName",
  "addButton": "_7wPzUq_addButton",
  "amountPaidText": "_7wPzUq_amountPaidText",
  "bookingPriceDetails": "_7wPzUq_bookingPriceDetails",
  "bookingRedeem": "_7wPzUq_bookingRedeem",
  "bookingRedeemContentDetails": "_7wPzUq_bookingRedeemContentDetails",
  "bookingRedeemSelectedBanner": "_7wPzUq_bookingRedeemSelectedBanner",
  "bookingRedeemerCard": "_7wPzUq_bookingRedeemerCard",
  "bookingRedeemerCardContent": "_7wPzUq_bookingRedeemerCardContent",
  "bookingRedeemerCardHeader": "_7wPzUq_bookingRedeemerCardHeader",
  "bookingRedeemerUsps": "_7wPzUq_bookingRedeemerUsps",
  "contentContainer": "_7wPzUq_contentContainer",
  "descriptionTexts": "_7wPzUq_descriptionTexts",
  "imageWrapper": "_7wPzUq_imageWrapper",
  "location": "_7wPzUq_location",
  "removeButton": "_7wPzUq_removeButton",
  "uspIcon": "_7wPzUq_uspIcon",
  "uspItem": "_7wPzUq_uspItem",
  "wrapper": "_7wPzUq_wrapper",
});
